<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">
    <g fill="#006252">
      <path d="M1 1h6.39v6.39H1V1ZM1 8.61h6.39V15H1V8.61ZM8.61 1H15v6.39H8.61V1ZM8.61 8.61H15V15H8.61V8.61Z" />
    </g>
  </svg>
</template>
